import { createSelector } from 'reselect';

const selectorPickUpProcess = (state: any) => state.ReportComplaintState;

export const makeCustomerProductComplaintReportListSelector = () =>
  createSelector(selectorPickUpProcess, state => state.customerProductList);
export const makeCustomerNameSelector = () =>
  createSelector(selectorPickUpProcess, state => state.customerName);
